"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocalStorageService = (function () {
    function LocalStorageService() {
        this.KEY = 'adobe-launch-event-storage';
    }
    LocalStorageService.prototype.getKey = function () {
        return this.KEY;
    };
    LocalStorageService.prototype.get = function () {
        var storageItem = localStorage.getItem(this.KEY);
        return storageItem ? JSON.parse(storageItem) : new Array();
    };
    LocalStorageService.prototype.addEventDataItem = function (event) {
        var eventDataItems = this.get();
        eventDataItems.push(event.getData());
        this.save(eventDataItems);
    };
    LocalStorageService.prototype.save = function (eventDataItems) {
        localStorage.setItem(this.KEY, JSON.stringify(eventDataItems));
    };
    LocalStorageService.prototype.clear = function () {
        localStorage.removeItem(this.KEY);
    };
    LocalStorageService.prototype.removeItem = function (key) {
        var dataItems = this.get();
        var updatedEventDataItems = dataItems.filter(function (item) { return item.event !== key; });
        if (updatedEventDataItems.length < dataItems.length) {
            this.save(updatedEventDataItems);
        }
    };
    LocalStorageService.prototype.hasItem = function (key) {
        return this.get().some(function (item) { return item.event === key; });
    };
    return LocalStorageService;
}());
exports.default = LocalStorageService;
//# sourceMappingURL=LocalStorageService.js.map